
interface EmptyMealsStateProps {
  onCreate: () => void;
}

const EmptyMealsState = ({ onCreate }: EmptyMealsStateProps) => {
  return (
    <div className="text-center py-12">
      <h3 className="text-lg font-medium text-gray-900 mb-2">No meals yet</h3>
      <p className="text-gray-500 mb-4">Get started by creating your first meal listing.</p>
      <button
        onClick={onCreate}
        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-black/90 focus:outline-none"
      >
        Create Your First Meal
      </button>
    </div>
  );
};

export default EmptyMealsState;
